// src/config/categoryImages.js

const CATEGORY_IMAGES = {

    CEREAL:
        "/images/product-images/cereals/cereal-1.jpeg",

    LEGUME:
        "/images/product-images/legumes/legume1.jpeg",

    TUBER:
        "/images/product-images/tubers/tuber3.jpeg",

    SPICE:
        "/images/product-images/spices/spice1.jpeg",

    HERB:
        "/images/product-images/herbs/moringa/moringa-1.jpeg",

    FRUIT:
        "/images/product-images/fruits/fruit1.jpeg",

    LIVESTOCK:
        "/images/product-images/livestocks/livestock1.jpeg",

    RAW_MATERIAL:
        "/images/product-images/raw_materials/raw_material1.jpeg",

    OIL_CROP:
        "/images/product-images/oilseeds/oilseed1.jpeg",

    VEGETABLE:
        "/images/product-images/vegetables/vegetable1.jpeg",

    FLOWER:
        "/images/product-images/flowers/hibiscus-flower/hibiscus-flower-1.jpeg",

    default:
        "/images/product-images/cereals/cereal-1.jpeg"
};

export default CATEGORY_IMAGES;